<template>
	<div class="article">
		<div class="list">
			<div class="list-div"  v-for="(item,index) in list" :key="index">
				<div class="list-div1">
					<router-link :to="'/articledetails?id='+item.id">
					
					<div class="title">{{item.title}}</div>
					<div class="connet">{{item.brief}}</div>
					<div class="top">
						<div class="div1">
							<img :src="item.sponsor.avatar" />
							<div>{{item.sponsor.username}}</div>
						</div>
						<div>
							<img src="../../assets/shudo/images/u2464.png" />
							<div>{{item.create_time|slice}}</div>
						</div>
						<div>
							<img src="../../assets/shudo/images/u2465.png" />
							<div>21</div>
						</div>
						<div>
							<img src="../../assets/shudo/images/u2466.png" />
							<div>30</div>
						</div>
					</div>
					</router-link>
					
				</div>
			</div>
		
		</div>
	</div>
</template>

<script>
	export default {
	    data() {
			return {
				list : [],
				sponsor_id:'',
				list : []
			}
	    },
		created() {
			let that = this;
			var  query = that.$route.query;
			if(query.sponsor_id){
				that.sponsor_id = query.sponsor_id;
				console.log(22);
				that.$http('get','/api/v1/sponsor/article?three_id='+that.sponsor_id,{}) .then(function (res) {
					that.list = res.data.list;
					console.log(that.list);
				});
				
			}
		},
		methods:{
			
			visitorClick(){
				let that =this;
				that.$http('post','/api/v1/merchant/merchantuseradd',{merchant_id:that.merchanthot_id,type:0}) .then(function (res) {
					that.$message({message: res.msg,type: 'success'});
				});
			}
		},
	}
</script>

<style lang="less">
	.article {
		width: 100%;
		.list {
			width: 80%;
			min-height: 30rem;
			margin: auto;
			.list-div {
				width: 100%;
				background-color: #FFFFFF;
				height: 8.5rem;
				margin-top:1.2rem;
				.list-div1 {
					width: 88%;
					margin: auto;
					.title {
						padding-top: 1rem;
						font-size: 1rem;
						height: 1.8rem;
						color: #000000;
					}
					.connet {
						font-size: 0.7rem;
						color: #A4A1A6;
						height: 3rem;
					}
					.top {
						display: flex;
							color: #A4A1A6;
						div {
							// min-width: 5rem;
							display: flex;
							margin-left: 0.4rem;
							height: 2rem;
							line-height: 3rem;
							font-size: 0.6rem;
							img {
								position: relative;
								top: 1rem;
								width: 1rem;
								height: 1rem;
							}
							
							
						}
						.div1 {
							font-size: 1.6rem !important;
							margin-left: 0;
							width: 8rem;
							img {
								position: relative;
								top: 0.6rem;
								width: 1.6rem;
								height: 1.6rem;
							}
							div {
								line-height: 2.6rem;
								font-size: 0.875rem;
							}
							
						}
					}
					
				}
			}
		}
		
	}
</style>
